import { useEffect, useRef, useState } from "react";
import { TooltipContent, TooltipTrigger } from "./styled";
import { TooltipPortal } from "./TooltipPortal";
import { isTouchDevice } from "../../utils/constants";

export function TooltipIcon({
  children,
  tooltipText,
  position = "top",
  delay = 200,
}) {
  const [isVisible, setIsVisible] = useState(false);
  const [timeoutId, setTimeoutId] = useState(null);
  const [coords, setCoords] = useState({});
  const triggerRef = useRef();
  const needPreventClickRef = useRef(false);

  const updateTooltipPosition = () => {
    if (triggerRef.current) {
      const rect = triggerRef.current.getBoundingClientRect();
      setCoords({
        top: rect.top + window.scrollY,
        left: rect.left + window.scrollX,
        width: rect.width,
        height: rect.height,
      });
    }
  };

  const showTooltip = () => {
    updateTooltipPosition();
    const id = setTimeout(() => {
      updateTooltipPosition();
      setIsVisible(true);
    }, delay);
    setTimeoutId(id);
  };

  const hideTooltip = () => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    setIsVisible(false);
  };

  useEffect(() => {
    const handleScroll = () => isVisible && updateTooltipPosition();
    window.addEventListener("scroll", handleScroll, true);
    window.addEventListener("resize", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll, true);
      window.removeEventListener("resize", handleScroll);
    };
  }, [isVisible]);

  return (
    <>
      <TooltipTrigger
        ref={triggerRef}
        onMouseEnter={!isTouchDevice ? showTooltip : undefined}
        onMouseLeave={!isTouchDevice ? hideTooltip : undefined}
        onClick={(e) => {
          if (needPreventClickRef.current) {
            e.preventDefault();
            e.stopPropagation();

            needPreventClickRef.current = false;
          }
        }}
        onTouchStart={() => {
          needPreventClickRef.current = true;
        }}
        onTouchMove={() => {
          needPreventClickRef.current = false;
        }}
        onTouchEnd={() => {
          if (needPreventClickRef.current) {
            showTooltip();

            setTimeout(hideTooltip, 2500);
          }
        }}
      >
        {children}
      </TooltipTrigger>

      {isVisible && (
        <TooltipPortal>
          <TooltipContent
            position={position}
            visible={isVisible}
            coords={coords}
          >
            {tooltipText}
          </TooltipContent>
        </TooltipPortal>
      )}
    </>
  );
}
